module.exports = __webpack_public_path__ + "static/media/tire-repair.827c5511.svg";